export function typeToText(type: string): string {
    switch (type) {
        case "CARD":
            return "Карта";
        case "SBP":
            return "СБП";
        case "CARD_EXTERNAL":
            return "Заграничная карта";
        case "SBP_EXTERNAL":
            return "Заграничный СБП";
        case "LINK":
        case "QR":
            return "Ссылка";
    }
    return type;
}